import { ReactNode } from 'react'

import { Flex } from './Flex'
import { Icon, IconName } from './Icon'
import { Paragraph } from './Paragraph'
import { Text } from './Text'
import { Color } from '../constants'
import { StyleProps } from '../utils'

export type EmptyStateProps = {
  children?: ReactNode
  heading?: ReactNode
  headingStyles?: StyleProps
  icon?: IconName
  paragraph?: string
  paragraphStyles?: StyleProps
  styles?: StyleProps
}

export const EmptyState = (props: EmptyStateProps) => {
  return (
    <Flex
      col
      gap={3}
      items="center"
      justify="center"
      styles={{ height: '100%', px: 3, py: 4, width: '100%', ...props.styles }}
    >
      {props.icon && (
        <Icon
          color={Color.DARKEST_MEDIUM_GREY}
          name={props.icon}
          round
          size="xl"
        />
      )}
      {props.heading && (
        <Text
          bold
          color={Color.CINDER}
          size={3}
          styles={{ maxWidth: 480, ...props.headingStyles }}
          textAlign="center"
        >
          {props.heading}
        </Text>
      )}
      {props.paragraph && (
        <Paragraph
          mb={0}
          styles={{
            maxWidth: 480,
            textAlign: 'center',
            ...props.paragraphStyles,
          }}
        >
          {props.paragraph}
        </Paragraph>
      )}
      {props.children}
    </Flex>
  )
}
